import { defineMessage } from 'services/localization';

export const messages = {
    sectionHeaderText: defineMessage('addresses'),
    defaultShippingColumnName: defineMessage('default_shipping'),
    defaultShippingTooltip: defineMessage('default_shipping'),
    defaultBillingColumnName: defineMessage('default_billing'),
    defaultBillingTooltip: defineMessage('default_billing'),
    labelColumnName: defineMessage('label'),
    countryColumnName: defineMessage('country'),
    attentionColumnName: defineMessage('attention'),
    addresseeColumnName: defineMessage('addressee'),
    phoneColumnName: defineMessage('phone_1'),
    primaryAddressColumnName: defineMessage('address_2'),
    secondaryAddressColumnName: defineMessage('address_3'),
    cityColumnName: defineMessage('city'),
    stateColumnName: defineMessage('state'),
    zipColumnName: defineMessage('zip'),
};
